// refill
export const PREPAID_REFILL_VERIFY_PHONE_NUMBER = "PREPAID_REFILL_VERIFY_PHONE_NUMBER";
export const PREPAID_REFILL_SET_REFILL_OPTION = "PREPAID_REFILL_SET_REFILL_OPTION";
export const PREPAID_REFILL_SUBMIT_ORDER = "PREPAID_REFILL_SUBMIT_ORDER";

// registration
export const PREPAID_REGISTRATION_ADD_PRODUCT_USER = "PREPAID_REGISTRATION_ADD_PRODUCT_USER";
export const PREPAID_REGISTRATION_ADD_SIM_AND_PHONE_NUMBER = "PREPAID_REGISTRATION_ADD_SIM_AND_PHONE_NUMBER";
export const PREPAID_REGISTRATION_VERIFY_UPDATED_NAME = "PREPAID_REGISTRATION_VERIFY_UPDATED_NAME";
